<template>
      <div class="lang-wrapper">
        <nav>
          <ul>
            <li v-for="lang in langs" :key="lang.idlang">
              <a @click.prevent="switchLang(lang.idlang)">{{ lang.dtlang }}</a>
            </li>
          </ul>
        </nav>
      </div>
</template>

<script>
export default {
    name: 'LangSelector',

    props: {
        langs: {
            type: Array
        }
    },

    methods: {
        switchLang(idlang) {
            this.$emit('switchLang', idlang)
        }
    }
}
</script>

<style scoped>
    a {
        text-transform: uppercase;
    }
</style>